var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.625V10.625M6.25 5.625V10.625M5 3.125C5 3.78804 5.26339 4.42393 5.73223 4.89277C6.20107 5.36161 6.83696 5.625 7.5 5.625C8.16304 5.625 8.79893 5.36161 9.26777 4.89277C9.73661 4.42393 10 3.78804 10 3.125C10 2.46196 9.73661 1.82607 9.26777 1.35723C8.79893 0.888392 8.16304 0.625 7.5 0.625C6.83696 0.625 6.20107 0.888392 5.73223 1.35723C5.26339 1.82607 5 2.46196 5 3.125ZM2.5 14.375H12.5V12.5H2.5V14.375ZM4.375 12.5H10.625V10.625H4.375V12.5Z",
    stroke: "black",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualIcon);
export default __webpack_public_path__ + "static/media/manualIcon.fcb347b9beeca3da9acc2f0c53a77b23.svg";
export { ForwardRef as ReactComponent };